import { useEffect, useState } from "react";
import api from "./Axios/api";
import { MaterialReactTable } from "material-react-table";
import { useParams } from "react-router-dom";

const ReportInfo = () => {
    const { date, voucherNo, factory } = useParams();
    const [consumptionData, setConsumptionData] = useState([]);
    const [productionData, setProductionData] = useState([]);
    const [totals, setTotals] = useState({ consumption: 0, production: 0 });

    const fetchData = async () => {
        try {
            const response = await api.get(`consumption/get-consumptions?insertDate=${date}`);
            const entry = response.data[0]; // only one entry per date

            // Find matching voucher in consumption
            const matchedConsumption = entry.consumption.find(
                (c) => c.voucherNo === voucherNo
            );

            // Find matching voucher in production (if any)
            const matchedProduction = entry.production?.find(
                (p) => p.voucherNo === voucherNo
            );

            // Flatten the nested consume_items[].items[]
            const flattenItems = (consumeItems) => {
                return consumeItems
                    ?.filter((ci) => ci.godown === factory)
                    .flatMap((ci) =>
                        ci.items.map((item) => ({
                            godown: ci.godown,
                            ...item,
                        }))
                    ) || [];
            };

            const calcTotal = (consumeItems = []) => {
                return consumeItems
                    .filter((ci) => ci.godown === factory)
                    .flatMap((ci) => ci.items)
                    .reduce((sum, item) => sum + parseFloat(item.amount || 0), 0);
            };

            setConsumptionData(flattenItems(matchedConsumption?.consume_items));
            setProductionData(flattenItems(matchedProduction?.consume_items));
            setTotals({
                consumption: calcTotal(matchedConsumption?.consume_items),
                production: calcTotal(matchedProduction?.consume_items),
            });
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const columnsConsumption = [
        { header: "ITEM_NAME", accessorKey: "itemName" },
        { header: "GODOWN", accessorKey: "godown" },
        { header: "QUANTITY", accessorKey: "quantity" },
        { header: "RATE", accessorKey: "rate" },
        { header: "AMOUNT", accessorKey: "amount" },
    ];

    const columnsProduction = [
        { header: "ITEM_NAME", accessorKey: "itemName" },
        { header: "LOCATION", accessorKey: "godown" },
        { header: "QUANTITY", accessorKey: "quantity" },
        { header: "RATE", accessorKey: "rate" },
        { header: "AMOUNT", accessorKey: "amount" },
    ];

    return (
        <div className="w-full bg-white flex justify-center mt-4">
            <div className="w-[98%] mt-4">
                <div className="w-[50%] mx-auto flex justify-between">
                    <h2>Voucher Number - {voucherNo}</h2>
                    <p>Date: {date}</p>
                </div>
                <div className="text-center font-medium mb-2">Factory: {factory}</div>

                <div style={{ display: "flex", gap: "10px" }}>
                    <div style={{ flex: 1 }} className="mt-4">
                        <h3>Source (Consumption)</h3>
                        <MaterialReactTable
                            columns={columnsConsumption}
                            data={consumptionData}
                        />
                    </div>

                    <div style={{ flex: 1 }} className="mt-4">
                        <h3>Destination (Production)</h3>
                        <MaterialReactTable
                            columns={columnsProduction}
                            data={productionData}
                        />
                    </div>
                </div>

                <div className="mt-10 flex mx-auto w-[60%] justify-between">
                    <div>
                        <strong>Total Consumption Amount:</strong> ₹{totals.consumption.toFixed(2)}
                    </div>
                    <div>
                        <strong>Total Production Amount:</strong> ₹{totals.production.toFixed(2)}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ReportInfo;